module.exports = __webpack_public_path__ + "img/right_md_5.39dc4eae.jpg";